module.exports = __webpack_public_path__ + "static/media/sfx_animal_chameleon.a8d7f7d4.mp3";